<template>
    <div class="container p-3 text-center">
        <div class="row">
            <div class="col p-3">
                <h1>Select a Portal</h1>            
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="border portal-box bg-light shadow-sm rounded p-4 mb-2">
                        <h2 class="tx-col">Health Plan Financial and Statistical Reporting</h2>
                            <b-button variant="primary" onclick="location.href='/home'" size="lg" type="button" title="Navigate to the Health Plan Financials and Statistical reporting portal." class="bt-bg">
                            Visit Portal</b-button>

                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <div class="border portal-box bg-light shadow-sm p-4 rounded">
                        <h2 class="tx-col">Health Care Entity Transactions</h2>
                        <b-button variant="primary" v-on:click="checkHceTxcontacts" size="lg" type="button" class="bt-bg">
                            Visit Portal</b-button>
                </div>
            </div>
        </div>
    </div>



</template>
<style>
.bt-bg {
    background-color: #003865;
}

.tx-p {
    padding: 1.5rem;
    height: 200px;
}

.card {
    border: 0px;
    border-radius: 0px;
}

.portal-box {
    height: 300px;
}

.tx-col {
    height: 75%;
}
</style>
<script>
import lambdaURL from '../../lambdahcetx'

export default {
    mounted() {
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        checkHceTxcontacts: async function () {
            try {
                this.loading = true;
                const response = await lambdaURL.checkHceTxContact(this.$keycloak.userName);
                if (response === 'Exists') {
                    window.location.href = '/hce/home';
                } else {
                    window.location.href = '/hce/createprofile';
                }
            } finally {
                this.loading = true;
            }

        }
    }
}
</script>